/* Modulo: Product Buy Box — section-product-buybox
   ─────────────────────────────────────────────────────────────────────────
   The variant matrix. Every other picker in this library handles ONE option,
   because one option means one variant and an unambiguous price. Here every
   option is live at once, so a value has to be struck out when no available
   variant can be reached through it given the other current choices.

   Two rules this file keeps:
   · It NEVER formats money. Every price string is pre-rendered by Liquid's
     `money` filter and carried in the variant table (a theme's own formatMoney
     is hostile — Ella's throws on a one-argument call).
   · It NEVER builds an image URL. The CDN width and the `?v=` cache key are
     baked in server-side.

   `moduloLazyInit` is deliberately not used: it does not exist in this repo
   (0 hits; modulo-core.js is not on disk) despite 61 files carrying the branch. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function init(root) {
    if (!root || root.dataset.pbbReady === '1') return;
    root.dataset.pbbReady = '1';

    var data;
    try {
      data = JSON.parse(root.dataset.pbbData || '{}');
    } catch (e) {
      return;
    }
    var variants = (data && data.variants) || [];
    if (!variants.length) return;

    var form      = root.querySelector('[data-pbb-form]');
    var priceEl   = root.querySelector('[data-pbb-price]');
    var wasEl     = root.querySelector('[data-pbb-was]');
    var saveEl    = root.querySelector('[data-pbb-save]');
    var selParts  = root.querySelector('[data-pbb-selparts]');
    var selPrice  = root.querySelector('[data-pbb-selprice]');
    var stockEl   = root.querySelector('[data-pbb-stock]');
    var atc       = root.querySelector('[data-pbb-atc]');
    var atcLabel  = root.querySelector('[data-pbb-atclabel]');
    var qInput    = root.querySelector('[data-pbb-qinput]');
    var qPlus     = root.querySelector('[data-pbb-qplus]');
    var qMinus    = root.querySelector('[data-pbb-qminus]');
    var shots     = root.querySelectorAll('[data-pbb-shot]');
    var thumbs    = root.querySelectorAll('[data-pbb-thumb]');

    /* The hidden `id` is inserted HERE rather than rendered by Liquid. The no-JS
       path is a <noscript> select also named `id`; rendering both would put two
       fields with that name in one form, and which one wins is undefined — the
       failure direction being "adds a variant the shopper did not choose". */
    var idInput = null;
    if (form) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      form.insertBefore(idInput, form.firstChild);
    }

    /* ── current selection, read off the rendered controls ── */
    function readSelection() {
      var sel = [null, null, null];
      var controls = root.querySelectorAll('[data-pbb-opt]');
      for (var i = 0; i < controls.length; i++) {
        var c = controls[i];
        var idx = parseInt(c.getAttribute('data-pbb-opt'), 10);
        if (isNaN(idx)) continue;
        if (c.tagName === 'SELECT') {
          sel[idx] = c.value;
        } else if (c.checked) {
          sel[idx] = c.value;
        }
      }
      return sel;
    }

    function sameOpts(v, sel) {
      for (var i = 0; i < 3; i++) {
        var a = v.o[i] === undefined ? null : v.o[i];
        var b = sel[i] === undefined ? null : sel[i];
        if (a !== b) return false;
      }
      return true;
    }

    /* A product with a single default variant renders NO option controls, so
       the read-off selection is [null,null,null] and matching on it finds
       nothing — which left the hidden `id` empty and the product unbuyable.
       With no controls there is nothing to choose, so the variant IS the first
       available one. */
    function hasControls() {
      return root.querySelectorAll('[data-pbb-opt]').length > 0;
    }

    function findVariant(sel) {
      if (!hasControls()) {
        for (var k = 0; k < variants.length; k++) if (variants[k].a) return variants[k];
        return variants[0];
      }
      for (var i = 0; i < variants.length; i++) {
        if (sameOpts(variants[i], sel)) return variants[i];
      }
      return null;
    }

    /* Can ANY available variant be reached with option `idx` set to `val`,
       holding every other current choice? That is what earns the strikethrough,
       and it is the same test the Liquid runs for first paint. */
    function reachable(sel, idx, val) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.a) continue;
        if (v.o[idx] !== val) continue;
        var hit = true;
        for (var k = 0; k < 3; k++) {
          if (k === idx) continue;
          var a = v.o[k] === undefined ? null : v.o[k];
          var b = sel[k] === undefined ? null : sel[k];
          if (a !== b) { hit = false; break; }
        }
        if (hit) return true;
      }
      return false;
    }

    /* A change can strand another option on a value nothing reaches any more.
       Heal it forward to the first reachable value rather than rendering a
       selection that resolves to no variant at all. */
    function heal(sel) {
      var groups = {};
      var controls = root.querySelectorAll('[data-pbb-opt]');
      for (var i = 0; i < controls.length; i++) {
        var idx = parseInt(controls[i].getAttribute('data-pbb-opt'), 10);
        if (isNaN(idx)) continue;
        if (!groups[idx]) groups[idx] = [];
        if (controls[i].tagName === 'SELECT') {
          var opts = controls[i].options;
          for (var j = 0; j < opts.length; j++) groups[idx].push(opts[j].value);
        } else {
          groups[idx].push(controls[i].value);
        }
      }
      for (var g in groups) {
        if (!Object.prototype.hasOwnProperty.call(groups, g)) continue;
        var gi = parseInt(g, 10);
        if (sel[gi] === null || reachable(sel, gi, sel[gi])) continue;
        var vals = groups[g];
        for (var v = 0; v < vals.length; v++) {
          if (reachable(sel, gi, vals[v])) { sel[gi] = vals[v]; break; }
        }
      }
      return sel;
    }

    /* ── paint ── */
    function applyAvailability(sel) {
      var controls = root.querySelectorAll('[data-pbb-opt]');
      for (var i = 0; i < controls.length; i++) {
        var c = controls[i];
        var idx = parseInt(c.getAttribute('data-pbb-opt'), 10);
        if (isNaN(idx)) continue;

        if (c.tagName === 'SELECT') {
          for (var j = 0; j < c.options.length; j++) {
            var o = c.options[j];
            var can = reachable(sel, idx, o.value);
            o.disabled = !can;
          }
          if (c.value !== sel[idx]) c.value = sel[idx];
        } else {
          var canPill = reachable(sel, idx, c.value);
          c.disabled = !canPill;
          c.checked = c.value === sel[idx];
          var label = c.getAttribute('aria-label') || '';
          label = label.replace(/, unavailable$/, '');
          c.setAttribute('aria-label', canPill ? label : label + ', unavailable');
        }

        var vlabel = root.querySelector('[data-pbb-optvalue="' + idx + '"]');
        if (vlabel && sel[idx]) vlabel.textContent = sel[idx];
      }
    }

    function showImage(imgId) {
      if (!imgId || !shots.length) return;
      var found = false;
      for (var i = 0; i < shots.length; i++) {
        if (String(shots[i].getAttribute('data-img-id')) === String(imgId)) found = true;
      }
      if (!found) return;
      for (var j = 0; j < shots.length; j++) {
        var on = String(shots[j].getAttribute('data-img-id')) === String(imgId);
        shots[j].classList.toggle('is-on', on);
      }
      for (var k = 0; k < thumbs.length; k++) {
        thumbs[k].setAttribute(
          'aria-current',
          String(thumbs[k].getAttribute('data-img-id')) === String(imgId) ? 'true' : 'false'
        );
      }
    }

    function paint() {
      var sel = heal(readSelection());
      applyAvailability(sel);

      var v = findVariant(sel);
      if (!v) return;

      if (idInput) idInput.value = v.id;

      if (priceEl) priceEl.textContent = v.p;
      if (wasEl) {
        if (v.c) { wasEl.textContent = v.c; wasEl.removeAttribute('hidden'); }
        else { wasEl.setAttribute('hidden', ''); }
      }
      if (saveEl) {
        if (v.c && v.pc > 0) { saveEl.textContent = v.pc + '% off'; saveEl.removeAttribute('hidden'); }
        else { saveEl.setAttribute('hidden', ''); }
      }

      if (atc) {
        atc.disabled = !v.a;
        if (atcLabel) atcLabel.textContent = v.a ? (atc.getAttribute('data-pbb-label') || atcLabel.textContent) : 'Sold out';
      }

      if (qInput) {
        var max = v.q || 1;
        qInput.max = max;
        if (parseInt(qInput.value, 10) > max) qInput.value = max;
        if (qPlus) qPlus.disabled = parseInt(qInput.value, 10) >= max;
        if (qMinus) qMinus.disabled = parseInt(qInput.value, 10) <= 1;
      }

      /* The signature line. Assembled from the resolved variant, never typed,
         so it cannot disagree with the price above it. It is the aria-live
         region, which is what a screen-reader user gets instead of inferring
         the current pick from three separate radio groups. */
      if (selParts) {
        var parts = [];
        for (var i = 0; i < 3; i++) if (sel[i]) parts.push(sel[i]);
        selParts.textContent = parts.join(' · ');
      }
      if (selPrice) selPrice.textContent = v.p;
      if (stockEl) {
        var txt = !v.a ? 'Sold out' : (v.q <= 3 ? 'Only ' + v.q + ' left' : 'En stock');
        stockEl.classList.toggle('modulo-pbb__stock--in', !!v.a);
        stockEl.classList.toggle('modulo-pbb__stock--out', !v.a);
        var dot = stockEl.querySelector('i');
        stockEl.textContent = txt;
        if (dot) stockEl.insertBefore(dot, stockEl.firstChild);
      }

      showImage(v.img);
    }

    /* Remember the merchant's own label before "Sold out" can overwrite it. */
    if (atc && atcLabel) atc.setAttribute('data-pbb-label', atcLabel.textContent.trim());

    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-pbb-opt')) paint();
    });

    if (qPlus) qPlus.addEventListener('click', function () {
      var max = parseInt(qInput.max, 10) || 10;
      qInput.value = Math.min((parseInt(qInput.value, 10) || 1) + 1, max);
      paint();
    });
    if (qMinus) qMinus.addEventListener('click', function () {
      qInput.value = Math.max((parseInt(qInput.value, 10) || 1) - 1, 1);
      paint();
    });
    if (qInput) qInput.addEventListener('input', function () {
      var n = parseInt(qInput.value, 10);
      var max = parseInt(qInput.max, 10) || 10;
      if (isNaN(n) || n < 1) return;             /* let the shopper clear it mid-type */
      if (n > max) qInput.value = max;
      paint();
    });

    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function () {
        showImage(this.getAttribute('data-img-id'));
      });
    }

    watchBuyControls(root);
    wireAppBlocks(root);
    wireCartAdd(form, atc, atcLabel);
    paint();
  }

  /* This section accepts app blocks, and an app block can take over parts of
     the buy row from its own JS. Our bundle block does both of these: it hides
     the quantity stepper, because its tier cards ARE the quantity choice, and
     it hides Shopify's dynamic checkout, because a wallet button bypasses the
     product form and would charge for one unit whatever tier was picked.

     Both leave a wrapper standing with its spacing intact — a 149px strip
     beside Add to cart, and a 10px strip under it — so the geometry has to
     follow the state rather than assume it.

     Watching the elements beats matching an inline style: any app hiding them
     any way is handled, with no coupling to how a particular one writes it.
     State is read at boot AND observed, because the app's JS and this file both
     run at DOMContentLoaded in an order neither controls, so an observer alone
     would miss a control hidden before it was attached. `childList` on the
     parents covers an app that removes a control outright instead of hiding
     it, which no attribute filter would ever see. */
  function watchBuyControls(root) {
    var form = root.querySelector('[data-pbb-form]');
    if (!form) return;

    var watched = [
      { el: root.querySelector('[data-pbb-qty]'), cls: 'modulo-pbb__form--noqty' },
      { el: form.querySelector('.shopify-payment-button'), cls: 'modulo-pbb__form--nodyn' },
    ];

    function sync() {
      for (var i = 0; i < watched.length; i++) {
        var w = watched[i];
        if (!w.el) continue;
        var gone = !w.el.isConnected || getComputedStyle(w.el).display === 'none';
        form.classList.toggle(w.cls, gone);
      }
    }

    sync();
    if (typeof MutationObserver !== 'function') return;
    var obs = new MutationObserver(sync);
    for (var i = 0; i < watched.length; i++) {
      var el = watched[i].el;
      if (!el) continue;
      /* Only the attributes that can carry the change, so ordinary work on a
         control (value updates, aria state) never wakes this up. */
      obs.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
      if (el.parentElement) obs.observe(el.parentElement, { childList: true });
    }
  }

  /* Our block loop runs inside `{% form 'product' %}`, so an app block lands
     inside the product form — see the comment on the `@app` branch in the
     Liquid for why that placement is the one that lets merchants interleave
     app blocks with the buy controls.

     The cost of it is this: a `<button>` with no `type` defaults to `submit`,
     so a third-party block that ships one would fire an add-to-cart on click.
     Most app blocks are written against Dawn, where they sit OUTSIDE the form
     and the default is harmless. Typing them explicitly is the narrowest fix —
     it changes nothing about how the block looks or behaves, only which form it
     is allowed to submit — and it is scoped to app-block wrappers so this can
     never touch our own controls. A block carrying its own submit button that
     really meant it will have declared a type, and is left alone. */
  function wireAppBlocks(root) {
    var form = root.querySelector('[data-pbb-form]');
    if (!form) return;
    var wraps = form.querySelectorAll(':scope > .shopify-block, :scope > .shopify-app-block');
    if (!wraps.length) return;

    function tame(scope) {
      var btns = scope.querySelectorAll('button:not([type])');
      for (var b = 0; b < btns.length; b++) btns[b].setAttribute('type', 'button');
    }

    /* An app block that renders nothing on this product must take up no space
       — ours renders nothing whenever the product is in no bundle, which is
       most products in most stores. The stylesheet expresses this twice: with
       `:has()` for the pre-JS paint, and with this class, which is the half
       that always works and the only half that can reach the block ABOVE an
       empty wrapper (`:has()` cannot be nested inside `:has()`). */
    function markEmpty(wrap) {
      wrap.classList.toggle('modulo-pbb__appblock--empty', wrap.children.length === 0);
    }

    function pass(wrap) {
      tame(wrap);
      markEmpty(wrap);
    }

    for (var i = 0; i < wraps.length; i++) pass(wraps[i]);

    /* Review and loyalty widgets commonly hydrate after load, so their content
       does not exist yet at boot — a wrapper can stop being empty, and buttons
       can appear. `childList` only: both actions here are attribute writes, so
       neither can retrigger this observer. */
    if (typeof MutationObserver !== 'function') return;
    var obs = new MutationObserver(function (records) {
      var seen = [];
      for (var r = 0; r < records.length; r++) {
        for (var w = 0; w < wraps.length; w++) {
          if (wraps[w].contains(records[r].target) && seen.indexOf(wraps[w]) < 0) seen.push(wraps[w]);
        }
      }
      for (var s = 0; s < seen.length; s++) pass(seen[s]);
    });
    for (var w2 = 0; w2 < wraps.length; w2++) obs.observe(wraps[w2], { childList: true, subtree: true });
  }

  /* ── Add to cart ─────────────────────────────────────────────────────────
     PROGRESSIVE ENHANCEMENT, never a rewrite. The markup stays a real
     {% form 'product' %}, so with JS off — or in the window before this
     deferred file runs — the button is still a native POST that adds the item
     and lands the shopper on /cart. What this adds is the in-place path: add
     without leaving the page, then tell the theme its cart changed.

     WHY THIS HAD TO EXIST AT ALL

     This section shipped with no cart JavaScript, on the assumption that a
     native form POST is the theme's business. Two things make that wrong:

       · A merchant reported (2026-09-06) that adding here left their cart
         showing empty until a reload. It was not the theme intercepting us —
         it was OUR OWN bundle app block, which renders inside this form and
         converts the submit into an AJAX add from a document-capture listener.
         So a section with zero cart code inherited a cart bug it had no code
         to fix, and grepping this file for "cart" found nothing.
       · The 2026-08-23 cart-notify fix covered the nine sections that POST to
         /cart/add.js. This one does not POST, so it was structurally outside
         that fix and outside the test that pins it.

     WHOSE HANDLER WINS

     `e.defaultPrevented` is the whole collision defence, and it works in both
     directions. Capture-phase listeners on ancestors run BEFORE any listener
     on the form, so the bundle block (document capture) has already claimed
     the event by the time we see it and we stand down — which is what stops a
     bundle tier being added twice. A theme that delegates on
     form[action*="/cart/add"] in the bubble phase runs AFTER us and is cut off
     by stopImmediatePropagation.

     What we cannot defend against is a theme listener registered on THIS form
     before ours that neither preventDefaults nor stops propagation. Nothing in
     the DOM lets a later listener detect an earlier one.
  */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function wireCartAdd(form, atc, atcLabel) {
    if (!form || !atc) return;
    /* init() re-runs on shopify:section:load, and the theme editor can replay
       it against a form we already bound. */
    if (form.getAttribute('data-pbb-cart') === '1') return;
    form.setAttribute('data-pbb-cart', '1');

    function label(text, ms) {
      if (!atcLabel) return;
      var keep = atc.getAttribute('data-pbb-label') || atcLabel.textContent;
      atcLabel.textContent = text;
      window.setTimeout(function () { atcLabel.textContent = keep; }, ms || 1800);
    }

    /* The submitter's own name/value is NOT in `new FormData(form)`. Passing it
       as the second argument is the only construction that keeps everything:
       properties[...], selling_plan, and any field an app block injected all
       ride along untouched, which a hand-built {items:[{id,quantity}]} body
       would silently drop. Older engines ignore the argument, so the submitter
       is re-appended by hand there. */
    function bodyFor(submitter) {
      var fd;
      try { fd = submitter ? new FormData(form, submitter) : new FormData(form); }
      catch (e) { fd = new FormData(form); }
      if (submitter && submitter.name && typeof fd.has === 'function' && !fd.has(submitter.name)) {
        fd.append(submitter.name, submitter.value || '');
      }
      return fd;
    }

    function send(submitter) {
      if (form.getAttribute('data-pbb-busy') === '1') return;
      form.setAttribute('data-pbb-busy', '1');

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        /* No Content-Type: the browser must set the multipart boundary itself.
           X-Modulo-Internal opts out of the bundle block's in-flight fetch
           shim, which otherwise answers with a synthetic 200 {"items":[]} and
           would have us report success on an add that never happened. */
        headers: { 'Accept': 'application/json', 'X-Modulo-Internal': 'product-buybox' },
        body: bodyFor(submitter)
      })
        .then(function (r) {
          if (r.ok) return r.json();
          return r.text().then(function (t) {
            var parsed = null;
            try { parsed = JSON.parse(t); } catch (e) { /* not JSON */ }
            var err = new Error(
              (parsed && (parsed.description || parsed.message)) ||
              (t && t.slice(0, 140)) || r.statusText || 'Could not add to cart'
            );
            err.status = r.status;
            throw err;
          });
        })
        .then(function () {
          label('Added');
          if (window.ModuloCart) window.ModuloCart.after();
        })
        .catch(function (err) {
          /* 422 is Shopify's cart-rule rejection and it is the one status where
             units can still have landed (a quantity clamped to available
             stock). Reporting the reason AND refreshing is the only honest
             pair: saying "failed" over a cart that did change is how a shopper
             ends up buying something twice. */
          if (err && err.status === 422 && window.ModuloCart) window.ModuloCart.after({ open: false });
          var reason = (err && err.message) ? err.message : 'Try again';
          label(reason.slice(0, 40), 2600);
        })
        .then(function () { form.setAttribute('data-pbb-busy', '0'); });
    }

    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;

      /* Enter in a text field reports no submitter, and that is still our add.
         A submit button belonging to a third-party block keeps whatever
         behaviour that app intended. */
      var submitter = e.submitter || null;
      if (submitter && submitter !== atc && !(atc.contains && atc.contains(submitter))) return;
      if (atc.disabled) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      send(submitter);
    });
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-pbb]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* An identical <script src> still executes once per tag, so the theme-editor
     listener is wired at most once. */
  if (!window.moduloPbbWired) {
    window.moduloPbbWired = true;
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  }
})();
